import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { errorCss } from '../../../ui/Form/baseStyles/index.styles';
import { Edges, VIEWPORTS } from '../../../../styles/Grid/GridSizes';

export const closeButtonCss = css({
  alignItems: 'center',
  background: 'none',
  border: 0,
  cursor: 'pointer',
  display: 'flex',
  height: 24,
  padding: 0,
  position: 'absolute',
  right: 24,
  top: 24,
  width: 'auto',
  zIndex: 2,
  [MediaQueries.mdAndUp]: {
    right: Edges[VIEWPORTS.md],
    top: 64,
  },
  [MediaQueries.lgAndUp]: {
    right: Edges[VIEWPORTS.lg],
    top: 96,
  },
  [MediaQueries.xl]: {
    right: Edges[VIEWPORTS.xl],
  },
});

export const iconCss = css({
  fontSize: 18,
  marginRight: 12,
});

export const pageComponent = {
  justifyContent: 'flex-start',
  [MediaQueries.lg]: {
    justifyContent: 'center',
    paddingBottom: '0px',
  },

  [MediaQueries.md]: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  '.header_left': {
    marginLeft: 0,
    [MediaQueries.lg]: {
      marginTop: '0px',
      marginLeft: '21% !important',
      width: '528px',
      height: '56px',
    },
    [MediaQueries.md]: {
      marginTop: '0px',
      marginLeft: '0px',
      width: '528px',
      height: '56px',
    },
  },
};

export const book_visit_head = {
  background: 'none',
  border: 'none',
  paddingTop: '34px',
  paddingBottom: '34PX',
  minHeight: '120px',
  textDecoration: 'none',
  display: 'flex',
  WebkitBoxAlign: 'center',
  alignItems: 'center',
  justifyContent: 'space-between',

  [MediaQueries.sm]: {
    flexDirection: 'column-reverse',
    alignItems: 'unset',
    justifyContent: 'start',
    paddingTop: '24px',
  },
  [MediaQueries.md]: {
    flexDirection: 'column-reverse',
    alignItems: 'end',
    justifyContent: 'start',
  },

  '@media screen and (min-width: 1280px) and (max-width: 1439px)': {
    '.header_left': { marginLeft: '8%', height: '56px' },
  },

  '@media screen and (min-width: 1024px) and (max-width: 1279px)': {
    flexDirection: 'column-reverse',
    alignItems: 'unset',
    justifyContent: 'start',
    paddingBottom: '0px',
    paddingTop: '40px',
    '.header_left': {
      marginLeft: '0% !important',
      marginTop: '20px',
      height: '56px',
    },
    '.header_right': { width: '100%', justifyContent: 'flex-end' },

    '.mid_sec': { '.rightside': { img: { width: '616px', height: '560px' } } },
  },

  '.header_left': {
    marginLeft: '8%',

    [MediaQueries.md]: {
      marginTop: '136px',
      marginLeft: '88px',
    },

    [MediaQueries.sm]: {
      marginLeft: '0',
      marginTop: '64px',
      'h2,h1': {
        fontSize: '34px',
        lineHeight: '40px',
      },
    },
    'h2,h1': {
      fontSize: '58px',
      lineHeight: '56px',
      letterSpacing: '-1px',
      fontWeight: '500',
      margin: 'auto',
      textAlign: 'left',

      '@media screen and (min-width: 1280px) and (max-width: 1439px)': {
        position: 'relative',
        top: '20px',
      },

      [MediaQueries.sm]: {
        fontSize: '34px',
        lineHeight: '40px',
      },
    },
  },

  '.header_right': {
    display: 'flex',
    [MediaQueries.sm]: {
      width: '100%',
      justifyContent: 'space-between',
    },
    [MediaQueries.md]: {
      width: '100%',
      justifyContent: 'flex-end',
    },
    '.call_section': {
      marginRight: '40px',
      display: 'flex',
      height: '23px',
      alignItems: 'center',

      '.icon_tel': {
        position: 'relative',
        top: '3px',
      },

      a: {
        color: '#393939',
        textDecoration: 'none',

        '.callustxt': {
          fontSize: '16px',
          lineHeight: '24px',
          letterSpacing: '0px',
          textAlign: 'left',
          fontWeight: '500',
          marginLeft: '10px',
          marginRight: '15px',
        },
        '.call_no': {
          [MediaQueries.sm]: {
            display: 'none',
          },
        },
      },
    },

    '.close-btn': {
      button: {
        i: {
          fontSize: '16px',
        },
        position: 'relative',
        top: '0px',
        right: '0px',
      },
    },
  },
};
